export class PlayPauseComponent extends Phaser.GameObjects.Container {
  /**
   *
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene, 0, 0);
    /**
     * @type {Phaser.Scene}
     */
    this.scene = scene;

    this.play_pause_button = this.scene.add
      .image(this.scene.game.config.width / 2, this.scene.game.config.height / 2, 'play_opensea')
      .setScale(0.125);

    this.add([this.play_pause_button]);
    this.setDepth(9999999);
    this.scene.add.existing(this);
  }
}
